// @flow
import type { Reducer } from "redux";
import type { ReduxAction } from "../types";
import type { RouterState } from "./types";

// REDUCER
const initialState: $Shape<RouterState> = {};

/**
 * Router reducer
 */
export const RouterReducer: Reducer<RouterState, ReduxAction> = (
  state = initialState,
  action = null,
) => {
  if (action && action.type === "ROUTER/LOCATION_CHANGE") {
    return action.payload;
  }

  return state;
};
